import AbstractEventCatcher from '../AbstractEventCatcher';
import { ticketChatActionCreators } from '../../../store/chat/resource/actions';

export default class TicketChatUnreadMessagesUpdated extends AbstractEventCatcher {
  static process({ unreadMessageInfo, dispatch }) {
    dispatch(
      ticketChatActionCreators.updateUnreadMessages(
        unreadMessageInfo.ticketId,
        unreadMessageInfo.chatId,
        unreadMessageInfo.unreadMessagesIds
      )
    );

    dispatch(
      ticketChatActionCreators.updateLastReadMessageId(
        unreadMessageInfo.ticketId,
        unreadMessageInfo.chatId,
        unreadMessageInfo.lastReadMessage?.id
      )
    );

    if (unreadMessageInfo.lastReadMessage) {
      dispatch(
        ticketChatActionCreators.addMessage(
          unreadMessageInfo.ticketId,
          unreadMessageInfo.chatId,
          unreadMessageInfo.lastReadMessage
        )
      );
    }

    dispatch(
      ticketChatActionCreators.setHistoryLastReadMessage(
        unreadMessageInfo.ticketId,
        unreadMessageInfo.chatId
      )
    );
  }
}
